import { SelectAll, Straighten } from "@mui/icons-material"
import type { FactorRule } from "./types"

interface ItemIconProps {
  item: FactorRule
}

export function ItemIcon({ item }: ItemIconProps) {
  if (item.type === "factor") {
    return <SelectAll />
  }
  return <Straighten />
}
